import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../components/Button/Button';

import styles from './TerminalSettings/terminal.scss';

const getTerminalAvatar = (terminalType) => {
    switch (terminalType) {
        case 'Yookassa':
            return './assets/dispurse_app_blue.svg';
        case 'Tinkoff':
            return './assets/tinkoff_app.svg';
        default:
            return '';
    }
};

export default function Terminal(props) {
    const { title, description, onSetup, id, type, serviceId } = props;

    function handleSetup() {
        if (typeof onSetup === 'function') {
            onSetup(id, serviceId);
        }
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.logo} style={{ backgroundImage: `url(${getTerminalAvatar(type)})` }}></div>
                <div className={styles.info}>
                    <h2 className={styles.title}>{title}</h2>
                    <p className={styles.description}>{description}</p>
                </div>
                <div className={styles.actions}>
                    <Button size="s" level={'secondary'} text={'Настроить'} onClick={handleSetup} />
                </div>
            </div>
        </div>
    );
}

Terminal.propTypes = {
    id: PropTypes.number,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onSetup: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['Tinkoff', 'Yookassa']),
    serviceId: PropTypes.number,
};
